import type { RaceWeekEvent } from '../types';

// From context-chicago/itinerary-verification.md (city events and live sport, 6–15 Oct 2026).
export const chicagoCityEvents: RaceWeekEvent[] = [
  {
    date: '2026-10-07',
    time: '15:00',
    title: 'White Sox v Guardians · ALDS Game 3',
    kind: 'sport',
    location: 'Rate Field · 333 W 35th St',
    description:
      'Chicago’s only home playoff baseball this October — the Cubs went out in the Wild Card round. Game 3 of a best-of-five is always played. Red Line to Sox-35th. Clashes with the afternoon arrival on AA2998.',
    booking: 'Tickets required.',
  },
  {
    date: '2026-10-07',
    time: '19:00',
    title: 'Bulls preseason v Phoenix Suns',
    kind: 'sport',
    location: 'United Center',
    description: 'Preseason NBA.',
  },
  {
    date: '2026-10-09',
    time: '19:00',
    title: 'Chicago Bulls v Memphis Grizzlies',
    kind: 'sport',
    location: 'United Center · 1901 W Madison St',
    description: 'Preseason NBA. Booked — seated night out on load day.',
    planned: true,
  },
  {
    date: '2026-10-08',
    time: '16:00',
    title: 'White Sox ALDS Game 4 (if necessary)',
    kind: 'sport',
    location: 'Rate Field · 333 W 35th St',
    description: 'Only played if neither side has won the series in three.',
  },
  {
    date: '2026-10-10',
    time: '13:30',
    title: 'Chicago Fire v NYCFC',
    kind: 'sport',
    location: 'Soldier Field',
    description: 'MLS. Not one for race eve — skip unless you’re not running.',
  },
  {
    date: '2026-10-12',
    time: '12:00',
    title: '74th Columbus Day Parade',
    kind: 'city',
    location: 'State St, Wacker Dr → Van Buren St',
    description:
      'Downtown State St. Federal holiday — banks and post offices shut, but museums, AIRE and restaurants are open. Head west before noon.',
  },
];
